var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 20,
    viewBox: "0 0 11 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.73785 18.9584C5.50009 18.9584 5.30713 18.7654 5.30713 18.5276V9.91315C5.30713 9.67625 5.50009 9.48242 5.73785 9.48242C5.97561 9.48242 6.16858 9.67625 6.16858 9.91315V18.5276C6.16858 18.7654 5.97561 18.9584 5.73785 18.9584Z",
    fill: "#C7CEDD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.73785 18.9584C5.50009 18.9584 5.30713 18.7654 5.30713 18.5276V9.91315C5.30713 9.67625 5.50009 9.48242 5.73785 9.48242C5.97561 9.48242 6.16858 9.67625 6.16858 9.91315V18.5276C6.16858 18.7654 5.97561 18.9584 5.73785 18.9584Z",
    stroke: "#C7CEDD",
    strokeWidth: 0.221491
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.73785 1.72961C3.60059 1.72961 1.86133 3.46888 1.86133 5.60613C1.86133 7.74339 3.60059 9.48265 5.73785 9.48265C7.8751 9.48265 9.61437 7.74339 9.61437 5.60613C9.61437 3.46888 7.8751 1.72961 5.73785 1.72961ZM5.73785 10.3441C3.12593 10.3441 0.999878 8.21891 0.999878 5.60613C0.999878 2.99336 3.12593 0.868164 5.73785 0.868164C8.34976 0.868164 10.4758 2.99336 10.4758 5.60613C10.4758 8.21891 8.34976 10.3441 5.73785 10.3441Z",
    fill: "#C7CEDD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.73785 1.72961C3.60059 1.72961 1.86133 3.46888 1.86133 5.60613C1.86133 7.74339 3.60059 9.48265 5.73785 9.48265C7.8751 9.48265 9.61437 7.74339 9.61437 5.60613C9.61437 3.46888 7.8751 1.72961 5.73785 1.72961ZM5.73785 10.3441C3.12593 10.3441 0.999878 8.21891 0.999878 5.60613C0.999878 2.99336 3.12593 0.868164 5.73785 0.868164C8.34976 0.868164 10.4758 2.99336 10.4758 5.60613C10.4758 8.21891 8.34976 10.3441 5.73785 10.3441Z",
    stroke: "#C7CEDD",
    strokeWidth: 0.221491
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.73785 10.3441C3.12593 10.3441 0.999878 8.21891 0.999878 5.60613C0.999878 2.99336 3.12593 0.868164 5.73785 0.868164C8.34976 0.868164 10.4758 2.99336 10.4758 5.60613C10.4758 5.84389 10.2829 6.03686 10.0451 6.03686C9.80733 6.03686 9.61437 5.84389 9.61437 5.60613C9.61437 3.46888 7.8751 1.72961 5.73785 1.72961C3.60059 1.72961 1.86133 3.46888 1.86133 5.60613C1.86133 7.74339 3.60059 9.48265 5.73785 9.48265C5.97561 9.48265 6.16857 9.67562 6.16857 9.91338C6.16857 10.1511 5.97561 10.3441 5.73785 10.3441Z",
    fill: "#C7CEDD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.73785 10.3441C3.12593 10.3441 0.999878 8.21891 0.999878 5.60613C0.999878 2.99336 3.12593 0.868164 5.73785 0.868164C8.34976 0.868164 10.4758 2.99336 10.4758 5.60613C10.4758 5.84389 10.2829 6.03686 10.0451 6.03686C9.80733 6.03686 9.61437 5.84389 9.61437 5.60613C9.61437 3.46888 7.8751 1.72961 5.73785 1.72961C3.60059 1.72961 1.86133 3.46888 1.86133 5.60613C1.86133 7.74339 3.60059 9.48265 5.73785 9.48265C5.97561 9.48265 6.16857 9.67562 6.16857 9.91338C6.16857 10.1511 5.97561 10.3441 5.73785 10.3441Z",
    stroke: "#C7CEDD",
    strokeWidth: 0.221491
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.64734db62d64d2ab04fda76e35821175.svg";
export { ForwardRef as ReactComponent };